<template>
  <div>
    <van-field name="vehicleUsage" label="">
      <template #input>
        <van-radio-group v-model="radio" direction="horizontal" :disabled="disabled">
          <van-radio
            v-for="item in options"
            :key="item.typecode"
            :name="item.typecode"
            style="font-weight: bold !important; font-size: 1rem"
          >
            {{ item.typename }}
          </van-radio>
        </van-radio-group>
      </template>
    </van-field>
  </div>
</template>
<script>
  export default {
    props: {
      modelValue: {
        type: String,
        default: '',
      },
      options: {
        type: Array,
        default: () => [],
      },
      disabled: {
        type: Boolean,
        default: false,
      }
    },
    computed: {
      radio: {
        get() {
          return this.modelValue;
        },
        set(newVal) {
          this.$emit('update:modelValue', newVal);
          this.$emit('change', newVal);
        },
      },
    },
  };
</script>
<style lang="scss" scoped>
  .disabled-tip {
    color: #ff976a;
    font-size: 12px;
    margin: 4px 16px;
    padding-left: 12px;
    border-left: 2px solid #ff976a;
  }
</style>
